"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone, Mail, MapPin } from "lucide-react";
import { cn } from "@/lib/utils";
export default function SecureYourConsultation() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="secure-your-system" ref={sectionRef} className={cn("dark bg-[#161B22] text-[#FFFFFF] relative overflow-hidden py-24 lg:py-32", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_left,_#2D7FF9_0%,_transparent_25%)] opacity-10" />
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_bottom_right,_#BFFF00_0%,_transparent_20%)] opacity-5" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto flex flex-col items-center text-center space-y-16">
          <div className="space-y-6 max-w-3xl">
            <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-[#FFFFFF]">
              Secure Your <span className="text-[#BFFF00]">System</span>
            </h2>
            <p className="text-lg text-[#94A3B8] font-sans leading-relaxed">
              Unlock the full potential of Automated Growth Systems with AGS Partners. We provide the infrastructure, 
              compliance standards, and strategic consulting required to scale your enterprise.
            </p>
            <p className="text-sm text-[#94A3B8]/80 font-sans italic">
              AGS Partners is a wholly owned dba of Executive Sovereign Ventures LLC. © 2026 All Rights Reserved. 
              Compliant with Stripe and A2P standards.
            </p>
            <div className="flex flex-wrap justify-center gap-4 pt-4">
              <Button className="bg-[#BFFF00] text-[#0B0E14] hover:bg-[#BFFF00]/90 font-default font-bold uppercase tracking-wider h-12 px-8 rounded-lg transition-all hover:scale-[1.02] shadow-[0_0_15px_rgba(191,255,0,0.2)]">Initiate Strategy Session&nbsp;</Button>
              <Button variant="outline" className="border-[#FFFFFF20] text-[#FFFFFF] hover:bg-[#FFFFFF05] font-default font-bold uppercase tracking-wider h-12 px-8 rounded-lg transition-all">
                Learn More
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full pt-16 border-t border-[#FFFFFF10]">
            <div className="flex flex-col items-center space-y-4 group">
              <div className="flex-shrink-0 h-14 w-14 rounded-full bg-[#2D7FF9]/10 flex items-center justify-center text-[#2D7FF9] group-hover:bg-[#2D7FF9] group-hover:text-white transition-colors duration-300 shadow-[0_0_15px_rgba(45,127,249,0.2)]">
                <Phone className="h-7 w-7" />
              </div>
              <div>
                <p className="text-xs font-default font-medium text-[#94A3B8] uppercase tracking-widest mb-2">
                  Direct Line
                </p>
                <Link to="tel:+14695465998" className="text-xl font-default font-bold text-[#FFFFFF] hover:text-[#BFFF00] transition-colors block">(469) 546-5998</Link>
                <p className="text-xs text-[#94A3B8] font-sans mt-2">Technical Support</p>
              </div>
            </div>

            <div className="flex flex-col items-center space-y-4 group">
              <div className="flex-shrink-0 h-14 w-14 rounded-full bg-[#2D7FF9]/10 flex items-center justify-center text-[#2D7FF9] group-hover:bg-[#2D7FF9] group-hover:text-white transition-colors duration-300 shadow-[0_0_15px_rgba(45,127,249,0.2)]">
                <Mail className="h-7 w-7" />
              </div>
              <div>
                <p className="text-xs font-default font-medium text-[#94A3B8] uppercase tracking-widest mb-2">
                  Digital Inquiries
                </p>
                <Link to="mailto:contact@agssuite.com" className="text-lg font-default font-bold text-[#FFFFFF] hover:text-[#BFFF00] transition-colors break-all block">
                  contact@agssuite.com
                </Link>
                <p className="text-xs text-[#94A3B8] font-sans mt-2">
                  System Activation Desk
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center space-y-4 group">
              <div className="flex-shrink-0 h-14 w-14 rounded-full bg-[#2D7FF9]/10 flex items-center justify-center text-[#2D7FF9] group-hover:bg-[#2D7FF9] group-hover:text-white transition-colors duration-300 shadow-[0_0_15px_rgba(45,127,249,0.2)]">
                <MapPin className="h-7 w-7" />
              </div>
              <div>
                <p className="text-xs font-default font-medium text-[#94A3B8] uppercase tracking-widest mb-2">
                  HQ Operations
                </p>
                <p className="text-lg font-default font-bold text-[#FFFFFF]">
                  Automated Growth Systems
                </p>
                <p className="text-xs text-[#94A3B8] font-sans mt-2">
                  Digital First Organization
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}